/**
 * @generated SignedSource<<001fc527ee07be1649e219977ce256d5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PlannedItemIdInput = {
  id: string;
};
export type DeletePlannedItemDialogMutation$variables = {
  input: PlannedItemIdInput;
};
export type DeletePlannedItemDialogMutation$data = {
  readonly removePlannedItem: {
    readonly id: string;
  };
};
export type DeletePlannedItemDialogMutation = {
  response: DeletePlannedItemDialogMutation$data;
  variables: DeletePlannedItemDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "IdPayload",
    "kind": "LinkedField",
    "name": "removePlannedItem",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeletePlannedItemDialogMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeletePlannedItemDialogMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "5e06a8ed013185e8cbe2b7bf707482b0",
    "id": null,
    "metadata": {},
    "name": "DeletePlannedItemDialogMutation",
    "operationKind": "mutation",
    "text": "mutation DeletePlannedItemDialogMutation(\n  $input: PlannedItemIdInput!\n) {\n  removePlannedItem(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "e06c0c5fc636698c898d0f3fe2fcb826";

export default node;
